import { useState } from "react";
import { faqItems } from "@/mocks/categories";

export default function CTASection() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);

  return (
    <section className="py-14 md:py-20 px-4 md:px-12 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-10 md:gap-0">
          {/* Left - Visual */}
          <div className="lg:w-1/2 relative h-[350px] md:h-[500px] rounded-2xl overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Bold%20side%20by%20side%20visual%20concept%20showing%20a%20crumpled%20pile%20of%20messy%20receipts%20and%20paper%20notes%20on%20the%20left%20half%20versus%20a%20sleek%20laptop%20displaying%20an%20organized%20colorful%20spreadsheet%20on%20the%20right%20half%2C%20divided%20by%20a%20clean%20vertical%20line%20of%20light%2C%20dramatic%20contrast%20lighting%20with%20the%20laptop%20side%20bright%20and%20the%20paper%20side%20in%20shadow%2C%20conceptual%20editorial%20photography%20with%20powerful%20visual%20storytelling%20on%20a%20matte%20concrete%20surface&width=900&height=1100&seq=cta-compare-v2&orientation=portrait"
              alt="Compare ACBuySpreadsheet"
              title="ACBuySpreadsheet vs Traditional Shopping"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent"></div>
            <span className="absolute top-6 left-6 px-4 py-2 bg-background-50/80 backdrop-blur-sm text-foreground-800 text-xs font-medium rounded-full whitespace-nowrap">
              Compare &amp; Save
            </span>
            <p className="absolute bottom-6 left-6 font-heading text-3xl md:text-5xl text-background-50 leading-tight">
              ACBuy<br />vs<br />Old Way
            </p>
          </div>

          {/* Right - Table + FAQ */}
          <div className="lg:w-1/2 lg:pl-10 xl:pl-14 flex flex-col justify-center">
            <h3 className="font-heading text-2xl md:text-4xl text-foreground-950 leading-tight mb-8">
              Why Switch to<br />ACBuySpreadsheet?
            </h3>

            {/* Comparison Table */}
            <div className="overflow-x-auto mb-10">
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b-2 border-foreground-200">
                    <th className="text-left py-3 pr-4 font-semibold text-foreground-950 whitespace-nowrap">Feature</th>
                    <th className="text-center py-3 px-4 font-semibold text-primary-600 whitespace-nowrap">ACBuySpreadsheet</th>
                    <th className="text-center py-3 pl-4 font-semibold text-foreground-400 whitespace-nowrap">Traditional Shopping</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b border-foreground-100">
                    <td className="py-3 pr-4 text-foreground-700 whitespace-nowrap">Speed</td>
                    <td className="text-center py-3 px-4 text-primary-600 font-medium whitespace-nowrap">Ultra Fast</td>
                    <td className="text-center py-3 pl-4 text-foreground-400 whitespace-nowrap">Slow</td>
                  </tr>
                  <tr className="border-b border-foreground-100">
                    <td className="py-3 pr-4 text-foreground-700 whitespace-nowrap">Control</td>
                    <td className="text-center py-3 px-4 text-primary-600 font-medium whitespace-nowrap">Full</td>
                    <td className="text-center py-3 pl-4 text-foreground-400 whitespace-nowrap">Low</td>
                  </tr>
                  <tr className="border-b border-foreground-100">
                    <td className="py-3 pr-4 text-foreground-700 whitespace-nowrap">Data Tracking</td>
                    <td className="text-center py-3 px-4 text-primary-600 font-medium whitespace-nowrap">Advanced</td>
                    <td className="text-center py-3 pl-4 text-foreground-400 whitespace-nowrap">None</td>
                  </tr>
                  <tr>
                    <td className="py-3 pr-4 text-foreground-700 whitespace-nowrap">SEO Friendly</td>
                    <td className="text-center py-3 px-4 text-primary-600 font-medium whitespace-nowrap">Yes</td>
                    <td className="text-center py-3 pl-4 text-foreground-400 whitespace-nowrap">No</td>
                  </tr>
                </tbody>
              </table>
            </div>

            {/* FAQ */}
            <div className="space-y-2 mb-8">
              <h4 className="font-heading text-xl text-foreground-950 mb-4">Frequently Asked Questions</h4>
              {faqItems.map((item, idx) => (
                <div key={idx} className="border border-background-200/70 rounded-xl overflow-hidden">
                  <button
                    onClick={() => setOpenFaq(openFaq === idx ? null : idx)}
                    className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-200/40 transition-colors"
                  >
                    <span className="text-sm font-semibold text-foreground-900 pr-4">{item.question}</span>
                    <i className={`ri-${openFaq === idx ? "subtract" : "add"}-line text-foreground-400 flex-shrink-0`}></i>
                  </button>
                  {openFaq === idx && (
                    <div className="px-5 pb-4">
                      <p className="text-sm text-foreground-600 leading-relaxed">{item.answer}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>

            {/* CTA */}
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-7 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm rounded-full transition-all duration-300 self-start whitespace-nowrap cursor-pointer"
            >
              Buy It Now
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}